import React, { useCallback, useEffect } from "react";
import { Grid, Box, Switch } from "@mui/material";

import { GridSelectionModel } from "@mui/x-data-grid";

import { GridActionsCellItem, GridRowId } from "@mui/x-data-grid-pro";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
// import { object, string, TypeOf } from "zod";
import { confirm } from "react-confirm-box";
import Item from "../../Template/Item";
import { useDispatch, useSelector } from "react-redux";
import WithPermission from "../../components/WithPermission";
import TableSkeleton from "../../components/TableSkeleton";
import Dilogbox from "../../components/Dilogbox";
import { FacilityForm } from "./facility-form";
import {
  loadCompanies,
  trashCompany,
  blukTrashCompany,
  getCompany,
  updateCompanyStatus,
} from "../../redux/actions/company.actions";
import { storeStateType } from "../../redux/store";
import { ICompany } from "../../redux/reducers/company.reducer";
import { MultiFiltersType } from "../Worktype/Worktype";
import CustomDataGridPro from "../../components/CustomDataGridPro/CustomDataGridPro";
import CustomGridHeader from "../../components/CustomGridHeader";

const createTrashConfirmation = (message: string): any => ({
  render: (onConfirm: () => void, onCancel: () => void) => {
    return (
      <Dilogbox
        isDialogOpened={true}
        handleConfirmDialog={onConfirm}
        handleCloseDialog={onCancel}
        message={message}
      />
    );
  },
});

// type SearchContent = {
//   columnField: string;
//   opeartion?: string;
//   value: string;
// };

export default function Facility() {
  const dispatch = useDispatch();
  const [page, setPage] = React.useState<number>(0);
  const [selectionModel, setSelectionModel] =
    React.useState<GridSelectionModel>([]);
  const { companies, total, loading, current, company } = useSelector(
    (state: storeStateType) => state.company
  );

  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [editRequest, setEditRequest] = React.useState<boolean>(false);
  const [trashState, setTrashState] = React.useState<boolean>(true);
  const [handelaction, setHandelaction] = React.useState<string>("");
  const [pageSize, setPageSize] = React.useState<number>(10);
  const [filterData, setFilterrData] = React.useState<MultiFiltersType>({
    page: 1,
    size: 10,
  });
  const [stateFlag, setStateFlag] = React.useState<boolean>(false);
  const [paginationEvent] = React.useState<boolean>(false);
  const [csvData] = React.useState([]);
  const csvDownloadBtn = React.useRef<any>();
  const csvHeaders = [
    { label: `Facility Name`, key: "facility_name" },
    {
      label: `Facility Address`,
      key: "facility_address",
    },
    { label: "Contact Number", key: "facility_contact_number" },
    { label: "Email", key: "facility_contact_email" },
    { label: "Contact Person", key: "facility_contact_person" },
  ];

  const handleOpen = async () => {
    setHandelaction(`New facility`);
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (company && editRequest) {
      setIsOpen(true);
      setEditRequest(false);
    }
  }, [company, editRequest, setEditRequest, setIsOpen]);

  useEffect(() => {
    if (paginationEvent) {
      setFilterrData((prev) => ({ ...prev, page: page + 1 }));
      setStateFlag((preState) => !preState);
    }
  }, [page, paginationEvent]);

  const deleteCompany = React.useCallback(
    (id: GridRowId) => async () => {
      const message = "Do you want to delete the facility?";
      const result = await confirm(message, createTrashConfirmation(message));
      if (result) {
        const deleted = await dispatch<any>(trashCompany(id, filterData));
        if (deleted) {
          setSelectionModel([]);
          setTrashState(true);
        }
        return;
      }
    },
    [dispatch, filterData]
  );

  const editCompany = React.useCallback(
    (id: GridRowId) => async () => {
      setHandelaction("Edit Facility");
      dispatch<any>(getCompany(id));
      setEditRequest(true);
    },
    [dispatch]
  );

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    clickedRow: any
  ) => {
    const formData = new FormData();
    const data: any = event.target.checked;
    formData.append("facility_status", data);
    dispatch<any>(updateCompanyStatus(formData, clickedRow, filterData));
  };

  const label = { inputProps: { "aria-label": "Switch customfield" } };
  const columns = [
    { field: "sn", headerName: "S.N.", width: 10, filterable: false },
    { field: "facility_name", headerName: "Name", flex: 1 },
    { field: "facility_address", headerName: "Address", width: 200 },
    {
      field: "facility_contact_number",
      headerName: "Contact Number",
      width: 120,
    },
    {
      field: "facility_type",
      headerName: "Facility type",
    },
    { field: "facility_contact_email", headerName: "Email", width: 300 },
    {
      field: "facility_contact_person",
      headerName: "Contact Person",
      width: 150,
    },
    {
      field: "facility_status",
      headerName: "Active",
      width: 100,

      filterable: false,
      renderCell: (params: any) => (
        <Switch
          {...label}
          checked={params.row.facility_status}
          onChange={(e) => handleChange(e, params.row.id)}
        />
      ),
    },
    {
      field: "actions",
      type: "actions",
      minWidth: 20,
      flex: 0.1,
      getActions: (params: any) => [
        <GridActionsCellItem
          icon={<EditIcon />}
          label="Edit"
          showInMenu
          onClick={editCompany(params.id)}
          key="action-1"
        />,
        <GridActionsCellItem
          icon={<DeleteIcon />}
          label="Trash"
          showInMenu
          onClick={deleteCompany(params.id)}
          key="action-2"
        />,
      ],
    },
  ];

  const handleTrash = async () => {
    const count = selectionModel.length;
    const message =
      count === 1
        ? "Do you want to delete the selected facility?"
        : "Do you want to delete the selected facilities?";
    const result = await confirm(message, createTrashConfirmation(message));
    if (result) {
      const id = {
        data: {
          id: selectionModel,
        },
      };
      const deleted = await dispatch<any>(blukTrashCompany(id, filterData));
      if (deleted) {
        setSelectionModel([]);
        setTrashState(true);
      }
      return;
    }
  };

  let rows =
    Array.isArray(companies) && companies?.length >= 0
      ? companies.map((company: ICompany, index: number) => {
          let _id = current === 1 ? 1 : 10 * (current - 1) + 1;
          return {
            id: company.id,
            sn: index + _id,
            facility_name: company.facility_name,
            facility_address: company.facility_address,
            facility_contact_number: company.facility_contact_number,
            facility_contact_email: company.facility_contact_email,
            facility_status: company.facility_status,
            facility_contact_person: company.facility_contact_person,
            facility_type: company.facility_type,
          };
        })
      : [];

  useEffect(() => {
    dispatch<any>(loadCompanies(filterData));
  }, [stateFlag, dispatch, filterData]);

  useEffect(() => {
    if (csvData.length) {
      csvDownloadBtn.current.link.click();
    }
  }, [csvData]);

  const handleCloseFacilityForm = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <WithPermission
          roleReqiured={["ADMIN", "EMPLOYEE", "STAFF", "USER"]}
          message="Access Denied"
        >
          <Item>
            <CustomGridHeader
              title={`facility`}
              handleAddClick={handleOpen}
              handleBulkDelete={handleTrash}
              disabledTrashState={trashState}
            />

            <Box sx={{ height: 700, width: "100%" }}>
              {rows ? (
                <CustomDataGridPro
                  rows={rows}
                  columns={columns}
                  loading={loading}
                  totalRows={total}
                  setFilterData={setFilterrData}
                  filterData={filterData}
                  csvHeaders={csvHeaders}
                  exportCSVUrl="/facility/csv"
                  pageLimit={pageSize}
                  currentPage={page}
                  defaultCSVExport={false}
                  setPageLimit={setPageSize}
                  setCurrentPage={setPage}
                  handleRowSelectionModelChange={(newSelectionModel: any) => {
                    newSelectionModel.length
                      ? setTrashState(false)
                      : setTrashState(true);
                    setSelectionModel(newSelectionModel);
                  }}
                  csvFilename={`Facility`}
                />
              ) : (
                <TableSkeleton />
              )}
            </Box>
          </Item>
        </WithPermission>
      </Grid>
      <FacilityForm
        // titleName={menus["facility"] ?? ""}
        isDialogOpened={isOpen}
        handleCloseDialog={handleCloseFacilityForm}
        action={handelaction}
        filterData={filterData}
      />
    </Grid>
  );
}
